import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Company Service
 * Otobüs firma detay ve liste API'leri için servis
 */
export const busCompanyService = {
  /**
   * Otobüs firmaları listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.CompanyFirstLetter - Firma ilk harfi (örn: "A", boş string tümü)
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "CompanyFirstLetter": "",
   *   "LanguageCode": "tr"
   * }
   */
  getCompanyList: (
    payload = {},
    headers = {},
    hasErrorHandler = false
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyList,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma hakkında içeriklerini getir
   * @param {Object} payload - { CompanySlug, LanguageCode }
   */
  getCompanyAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma etiket/tag içeriklerini getir
   * @param {Object} payload - { CompanySlug, LanguageCode }
   */
  getCompanyTag: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyTag,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma SSS (FAQ) içeriklerini getir
   * @param {Object} payload - { CompanySlug, CurrencyCode, LanguageCode }
   */
  getCompanyFaq: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyFaq,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma için popüler rotaları getir
   * @param {Object} payload - { CompanySlug, CurrencyCode, LanguageCode }
   */
  getCompanyPopularRoutes: (
    payload = {},
    headers = {},
    hasErrorHandler = false
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyPopularRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma için popüler rota şehirleri ve merkezlerini getir
   * @param {Object} payload - { CompanySlug, CurrencyCode, LanguageCode }
   */
  getCompanyPopularRouteCitiesAndCenters: (
    payload = {},
    headers = {},
    hasErrorHandler = false
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyPopularRouteCitiesAndCenters,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma hizmet/servis bilgilerini getir
   * @param {Object} payload - { CompanySlug, LanguageCode }
   */
  getCompanyServices: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyServices,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Firma listesi hakkında içeriklerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getCompanyListAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.company.getCompanyListAbout,
      payload,
      headers,
      hasErrorHandler,
    }),
};

export default busCompanyService;


